import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Router from "./Router";
import registerServiceWorker from "./registerServiceWorker";
import "normalize.css";
import { ApolloClient } from "apollo-client";
import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloProvider } from "react-apollo";
import { Provider } from "react-redux";
import createStore from "./store";

const GRAPHCMS_API =
  "https://api-useast.graphcms.com/v1/cjnop1c100d6n01ghcdp9860a/master";

const client = new ApolloClient({
  link: new HttpLink({ uri: GRAPHCMS_API }),
  cache: new InMemoryCache()
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <Provider store={createStore}>
      <Router />
    </Provider>
  </ApolloProvider>,
  document.getElementById("root")
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js